import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "documents",
  "use": "documents-usage",
  "viewBox": "0 0 13.57 18.52",
  "content": "<symbol viewBox=\"0 0 13.57 18.52\" id=\"documents\">\r\n    <path d=\"M10.66,8.44H2.56a.38.38,0,0,1,0-.75h8.1a.38.38,0,1,1,0,.75Z\" />\r\n    <path d=\"M10.66,10.5H2.56a.38.38,0,1,1,0-.75h8.1a.38.38,0,1,1,0,.75Z\" />\r\n    <path d=\"M10.66,12.57H2.56a.38.38,0,1,1,0-.75h8.1a.38.38,0,1,1,0,.75Z\" />\r\n    <path d=\"M13.57,18.52H0V0H8.26l5.31,4.81ZM.75,17.77H12.82V5.14L8,.75H.75Z\" />\r\n    <path d=\"M13.2,5.35H7.74v-5a.38.38,0,0,1,.75,0V4.6H13.2a.37.37,0,0,1,0,.75Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol